import { ReportRef } from '@euler/app/flows/report/functions';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useIsMobileLayout } from '@euler/functions/responsiveness';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { DeliveryCheckSceneType } from '@euler/model/enum';
import { memo, useCallback } from 'react';
import { ScrollViewProps } from 'react-native';
import { ReportContentWrapper } from '../components/ReportContent';
import {
  ReportScreenProps,
  useReportContext,
} from '../components/ReportContext';
import { DeliveryCheckReportView } from '../components/delivery-check/DeliveryCheckReportView';
import { DeliveryCheckReportViewForIpad } from '../components/delivery-check/DeliveryCheckReportView.iPad';

const Content = memo(
  ({
    reportTarget,
    standalone,
    ...scrollViewProps
  }: ScrollViewProps & { reportTarget: ReportRef; standalone?: boolean }) => {
    const { report } = useReportContext();
    const isMobile = useIsMobileLayout();
    if (isMobile) {
      return (
        <DeliveryCheckReportView
          report={report}
          sceneType={DeliveryCheckSceneType.SamplingCheck}
          {...scrollViewProps}
        />
      );
    }
    return (
      <DeliveryCheckReportViewForIpad
        reportTarget={reportTarget}
        report={report}
        sceneType={DeliveryCheckSceneType.SamplingCheck}
        standalone={standalone}
      />
    );
  },
);

export const SamplingCheckReportScreen = wrapNavigatorScreen(
  ({ title, ...props }: ReportScreenProps) => {
    const { rpx } = useResponsiveContext();
    const isMobile = useIsMobileLayout();

    const reportTarget = props.target;

    const renderScrollView = useCallback(
      (scrollViewProps: ScrollViewProps) => {
        return <Content reportTarget={reportTarget} {...scrollViewProps} />;
      },
      [reportTarget],
    );

    return (
      <ReportContentWrapper
        tab="samplingCheck"
        title={title ?? '抽检报告'}
        {...props}
        renderScrollView={renderScrollView}
        shouldUseLandscapeLayout={!isMobile}
        ipadFooterStyle={{ paddingTop: rpx(15), paddingBottom: rpx(15) }}
      >
        <Content reportTarget={reportTarget} standalone={props.standalone} />
      </ReportContentWrapper>
    );
  },
  {
    headerShown: false,
    title: '抽检报告',
  },
);
